// External Dependencies:
import React from 'react'

// Internal Dependencies:
import Text from './Text'
import Textarea from './Textarea'
import Checkbox from './Checkbox'
import CheckboxButtons from './CheckboxButtons'
import RadioButtons from './RadioButtons'
import Select from './Select'
import { loop } from 'church-theme-library/utilities/objects'
import LoadScript from 'church-theme-library/containers/LoadScript'

class Form extends React.Component {
	constructor( props ) {
		super( props )

		let loadExtraJS = false

		if ( props.loadExtraJS ) {
			loadExtraJS = true
		}

		this.state = {
			loadExtraJS: loadExtraJS
		}
	}

	handleChange = ( id, value ) => {
		const { handleChange } = this.props

		if ( ! handleChange ) {
			return
		}

		handleChange( id, value )

		this.setState( {
			loadExtraJS: true
		} )
	}

	renderField = ( key, item ) => {
		let { values } = this.props

		if ( ! values ) {
			values = {}
		}

		let value = values[ key ]
		const id = `vl_form[fields][${item.id}]`

		switch ( item.type ) {
			case 'text':
				return (
					<Text
						key={ key }
						id={ id }
						label={ item.label }
						required={ item.required }
						onChange={ this.handleChange }
						uncontrolled={ true }
					/>
				)
				break

			case 'email':
				return (
					<Text
						key={ key }
						id={ id }
						label={ item.label }
						required={ item.required }
						onChange={ this.handleChange }
						type="email"
						uncontrolled={ true }
					/>
				)
				break

			case 'number':
				return (
					<Text
						key={ key }
						id={ id }
						label={ item.label }
						required={ item.required }
						onChange={ this.handleChange }
						type="number"
						uncontrolled={ true }
					/>
				)
				break

			case 'url':
				return (
					<Text
						key={ key }
						id={ id }
						label={ item.label }
						required={ item.required }
						onChange={ this.handleChange }
						type="url"
						uncontrolled={ true }
					/>
				)
				break

			case 'textarea':
				return (
					<Textarea
						key={ key }
						id={ id }
						label={ item.label }
						required={ item.required }
						onChange={ this.handleChange }
						uncontrolled={ true }
					/>
				)
				break

			case 'checkbox':
				return (
					<Checkbox
						key={ key }
						id={ id }
						label={ item.label }
						required={ item.required }
						onChange={ this.handleChange }
						uncontrolled={ true }
					/>
				)
				break

			case 'select':
				return (
					<Select
						key={ key }
						id={ id }
						label={ item.label }
						required={ item.required }
						options={ item.options }
						onChange={ this.handleChange }
						uncontrolled={ true }
					/>
				)
				break

			default:
				return null
		}
	}

	render() {
		const { data, values, wihtoutStore } = this.props
		const { loadExtraJS } = this.state
		let className = 'form vl-form'

		if ( ! data || ! data.id ) {
			return null
		}

		let markup = loop( data.fields, this.renderField )

		if ( data.recaptcha ) {
			className += ' has-recaptcha'
		}

		return (
			<form className={ className }>
				<input type="hidden" name="vl_form[id]" value={ data.id } />

				{ markup }

				{ data.recaptcha &&
					<div className="form-item">
						<div className="recaptcha"></div>
					</div>
				}

				{ ( loadExtraJS && data.recaptcha && ! wihtoutStore ) &&
					<LoadScript
						src="https://www.google.com/recaptcha/api.js"
					/>
				}

				<div className="form-item">
					<button className="button" type="submit"><span className="-state"></span><span className="-progress"></span>{ data.submit_text }</button>
				</div>
			</form>
		)
	}
}

export default Form
